import {
  red,
  pink,
  purple,
  deepPurple,
  cyan,
  teal,
  lime,
  lightGreen,
  green,
  amber,
  orange,
  deepOrange,
  blueGrey,
} from '@mui/material/colors';
const colors = [
  orange[500],
  red[500],
  green[500],
  teal[500],
  amber[500],
  blueGrey[500],
  purple[500],
  pink[500],
  cyan[500],
  deepOrange[500],
  lime[500],
];

const avatarBackgroundColors = [
  cyan[100],
  lightGreen[100],
  orange[100],
  lime[100],
  deepPurple[100],
  red[100],
  amber[100],
  pink[100],
  teal[100],
  blueGrey[100],
];

export function getColor(key) {
  return colors[key % 12];
}

export function getAvatarColor(key) {
  return avatarBackgroundColors[key % 12];
}
